// @flow

import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { fetchPosts } from "../api";
import actions from "../actions/index.js";
import usePageFromStore from "../hooks/usePageFromStore";
import addACFData from "../utils/addACFData";
import getContentReferenceTileProps from "../utils/getContentReferenceTileProps";

import SocialMediaFeed from "../components/organisms/SocialMediaFeed";
import TileSlider from "../components/organisms/TileSlider";
import HeroSports from "../components/organisms/HeroSports";
import IconCtaLinks from "../components/organisms/IconCtaLinks";
import TileRow from "../components/organisms/TileRow";
import SectionHeader from "../components/molecules/SectionHeader";
import Button from "../components/atoms/Button";
import Leaderboard from "../components/organisms/Leaderboard.js";

const Sports = (): any => {
    const { page } = usePageFromStore();
    const sports_category_ids = useSelector(
        (state: any): any => state.options.sports_category_ids
    );
    const [sports, setSports] = React.useState([]);
    const [events, setEvents] = React.useState([]);

    // Hero Content
    const hero = page.acf.hero;

    //Leaderboard
    const leaderboard = page.acf.bottom_leaderboard_ad
        ? getContentReferenceTileProps(
              addACFData(page.acf.bottom_leaderboard_ad)
          )
        : null;

    const random = () => {
        return 0.5 - Math.random();
    };

    useEffect(() => {
        const fetches = [];

        // sport id currently hardcoded
        const clubConfig: any = {
            postType: "clubs",
            perPage: 20,
            queryParms: {
                club_category: sports_category_ids.clubs_sport_id,
            },
        };

        const eventConfig: any = {
            orderby: "featured",
            postType: "events",
            queryParms: {
                event_category: sports_category_ids.event_sports_id,
            },
        };

        fetches.push(
            fetchPosts(clubConfig).then(({ data }: any) => {
                setSports(data.sort(random));
            })
        );

        fetches.push(
            fetchPosts(eventConfig).then(({ data, headers }: any) => {
                setEvents(data);
            })
        );

        // Wait for all promises to finish to stop loading
        Promise.all(fetches).then(actions.success).catch(actions.fail);
    }, []); // eslint-disable-line

    return (
        <>
            {/* Hero */}
            <HeroSports {...hero} />

            {page.acf.social_sports_links.links &&
            page.acf.social_sports_links.links.length > 0 ? (
                <IconCtaLinks {...page.acf.social_sports_links} />
            ) : null}

            {sports ? (
                <>
                    <div className="container-fluid sports-events__container">
                        <div className="row">
                            <div className="col-xs-12">
                                <SectionHeader
                                    sectionName="sports-tile-row"
                                    title={page.acf.club_list_title}
                                    cta={{
                                        link: {
                                            title: "All sports clubs",
                                            url: `/clubs?club_category=${sports_category_ids.clubs_sport_id}`,
                                        },
                                        type: "button",
                                    }}
                                />
                                <TileRow
                                    tiles={sports.slice(0, 6)}
                                    tileVariation="md"
                                    tileSize="col-xs-8 col-sm-4 col-md-2"
                                    className="tile-row--sports"
                                    noDescription
                                    noHeader
                                    mobileScrollable
                                />
                                <div className="tile-row--sports__cta">
                                    <Button
                                        customButton
                                        style={[]}
                                        to={`/clubs?club_category=${sports_category_ids.clubs_sport_id}`}
                                        target=""
                                        className={`button button--green hidden-sm`}
                                    >
                                        All sports clubs
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <hr />
                            </div>
                        </div>
                    </div>
                </>
            ) : null}

            {/* Get Involved - content slider component */}
            <TileSlider
                useContainer={true}
                colClass="col-xs-12"
                title={page.acf.get_involved.title}
                tiles={page.acf.get_involved.tiles}
            />

            {page.acf.get_involved ? (
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <hr />
                        </div>
                    </div>
                </div>
            ) : null}

            {/* Latest Events - content slider component */}
            {page.acf.get_involved ? (
                <>
                    <TileSlider
                        useContainer={true}
                        colClass="col-xs-12"
                        title="What's on"
                        tiles={events}
                        cta={page.acf.events_list_cta}
                    />

                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                <hr />
                            </div>
                        </div>
                    </div>
                </>
            ) : null}

            {/* High Performance - content slider component */}
            <TileSlider
                useContainer={true}
                colClass="col-xs-12"
                title={page.acf.high_performance.title}
                tiles={page.acf.high_performance.tiles}
            />

            {/* Leaderboard */}
            {leaderboard && (
                <Leaderboard
                    useContainer={true}
                    imageDesktop={leaderboard.image_desktop}
                    imageMobile={leaderboard.image_mobile}
                    alt={leaderboard.title}
                    link={leaderboard.url}
                    pageType="sports"
                    position="bottom"
                />
            )}

            {/* Social Media Feed */}
            <SocialMediaFeed type="sports" title="Follow UTS Sport" />
        </>
    );
};

export default Sports;
